var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('node-fetch'),
    Response = _require.Response,
    Headers = _require.Headers;

var mapKeys = require('lodash.mapkeys');

var identity = require('lodash.identity');

var FormData = require('form-data');
/**
 * A Fetch WebAPI implementation based on the Axios client
 */


function axiosFetch(_x, _x2, _x3) {
  return _axiosFetch.apply(this, arguments);
}

function _axiosFetch() {
  _axiosFetch = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(axios, transfomer, input) {
    var init,
        lowerCasedHeaders,
        config,
        result,
        responseBody,
        headers,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            init = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            // Convert the `fetch` style arguments into a Axios style config
            transfomer = transfomer || identity;
            lowerCasedHeaders = mapKeys(init.headers, function (value, key) {
              return key.toLowerCase();
            });

            if (!('content-type' in lowerCasedHeaders)) {
              lowerCasedHeaders['content-type'] = 'text/plain;charset=UTF-8';
            }

            config = transfomer({
              url: input,
              method: init.method || 'GET',
              data: init.body instanceof FormData ? init.body : String(init.body),
              headers: lowerCasedHeaders,
              validateStatus: function validateStatus() {
                return true;
              }
            }, input, init);
            _context.next = 7;
            return axios.request(config);

          case 7:
            result = _context.sent;
            // Convert the Axios style response into a `fetch` style response
            responseBody = typeof result.data === "object" ? JSON.stringify(result.data) : result.data;
            headers = new Headers();
            Object.entries(result.headers).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              headers.append(key, value);
            });
            return _context.abrupt("return", new Response(responseBody, {
              status: result.status,
              statusText: result.statusText,
              headers: headers
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _axiosFetch.apply(this, arguments);
}

function buildAxiosFetch(axios, transformer) {
  return axiosFetch.bind(undefined, axios, transformer);
}

module.exports = {
  buildAxiosFetch: buildAxiosFetch
};